<template>
  <div>
    <b-overlay :show="loading" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner/>
      </template>
      <b-card-title v-if="false" class="text-center slogan-text mb-5" title-tag="h2" v-html="$t('auth.socials.title')" />
      <div class="social-buttons">
        <div v-if="false" class="facebook-login-button social-button"
             :class="{'disable-button': !socialCheck}"
             @click="socialCheck ? loginWithFacebook() : showAcceptTerms()">
          <b-img :src="iconFacebook" class="mr-1"/>
          {{ $t('auth.socials.Connect via Facebook') }}
        </div>
        <div class="google-login-button social-button"
             :class="{'disable-button': !enableGoogleAuth || !socialCheck}"
             @click="enableGoogleAuth && socialCheck ? loginWithGoogle() : showAcceptTerms()">
          <b-img :src="iconGoogle" class="mr-1"/>
          {{ $t('auth.socials.Connect via Google') }}
        </div>
        <div
          v-if="false"
          class="apple-login-button social-button"
          :class="{'disable-button': !socialCheck}"
          @click="showAppleLoginInfoModal()">
          <b-img :src="iconApple" class="mr-1"/>
          {{ $t('auth.socials.Connect via Apple') }}
        </div>
        <div class="phone-login-button social-button"
             v-if="(!currentLocale) || (currentLocale && currentLocale.locale === 'tr')"
             :class="{'disable-button': !socialCheck}"
             @click="socialCheck ? triggerEmits([{event: 'updateActiveComponent', args: 'Phone'}, {event: 'updateBackButton', args: 'SocialButtons'}]) : showAcceptTerms()">
          <b-img :src="iconPhone" class="mr-1"/>
          {{ $t('auth.socials.Connect via Phone') }}
        </div>
        <div v-if="false"
             class="email-login-button social-button"
             :class="{'disable-button': !socialCheck}"
             @click="socialCheck ? triggerEmits([{event: 'updateActiveComponent', args: 'Email'}, {event: 'updateBackButton', args: 'SocialButtons'}]) : showAcceptTerms()">
          <b-img :src="iconEmail" class="mr-1" width="28"/>
          {{ $t('auth.socials.Connect via Email') }}
        </div>
        <div class="divider-container">
          <div class="divider-line"></div>
          <div class="divider-text">
            {{ $t('Or continue with email') }}
          </div>
          <div class="divider-line"></div>
        </div>
        <!-- form -->
        <validation-observer
          ref="emailForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="emailCheck"
          >
            <b-form-group
              label-for="login-email"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                vid="email"
                rules="required|email"
                data-vv-validate-on="blur"
              >
                <b-form-input
                  id="login-email"
                  v-model="email"
                  name="email"
                  :placeholder="$t('Email')"
                  :state="errors.length > 0 ? false:null"
                  style="border-radius: 12px !important; height: 3.2rem !important;"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div class="social-terms-check" :class="{'term-did-not-accepted': !socialCheck && termDidNotAccepted}">
              <input type="checkbox" id="socialCheck" v-model="socialCheck" class="mr-1">
              <label for="socialCheck" v-html="$t('socialCheckText')" />
            </div>
            <div v-if="!socialCheck && termDidNotAccepted" class="fs-14" style="color: red;">
              {{ $t('Please accept the membership agreement.') }}
            </div>
            <b-button
              v-if="!socialCheck"
              class="mt-1 mb-2 btn-primary2"
              variant="primary"
              block
              @click="showAcceptTerms"
            >
              <b-spinner
                v-if="loading"
                small
              />
              {{ $t('Login') }}
            </b-button>
            <b-button
              v-else
              class="mt-1 mb-2 btn-primary2"
              type="submit"
              variant="primary"
              block
              :disabled="loading || !socialCheck"
            >
              <b-spinner
                v-if="loading"
                small
              />
              {{ $t('Login') }}
            </b-button>
          </b-form>
        </validation-observer>
        <router-link v-if="false" :to="{name: 'public-users'}" class="visitor-button social-button">
          {{ $t('Continue as a visitor') }}
        </router-link>
      </div>
      <!-- Apple Login Info Modal -->
      <b-modal
        id="apple-info-modal"
        ref="appleInfoModal"
        centered
        :title="$t('apple.login.modal.title')"
        ok-only
        :ok-title="$t('Continue')"
      >
        <p>
          {{ $t('apple.login.modal.description', {emoji1: `‼️`, emoji2: `💬`, emoji3: `🎉`}) }}
          <!-- TODO: Update this message as needed -->
        </p>
      </b-modal>
      <!-- End Apple Login Info Modal -->
    </b-overlay>
  </div>
</template>

<script>
import { takeLoginRedirect } from '@/auth/utils'
import { initFbsdk } from '@/config/oAuth/facebook_oAuth.js'
import {
  BImg, BCardTitle, BOverlay, BFormInput, BForm, BButton, BFormGroup, BSpinner,
} from 'bootstrap-vue'
import { gtmTrackNewEvent, showNotify, throwDefaultError } from '@/helpers/helpers'
import useJwt from '@/auth/jwt/useJwt'
import { locales } from '@/libs/i18n/all-locales'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

const appUrl = process.env.VUE_APP_URL
const appleClientId = process.env.VUE_APP_APPLE_CLIENT_ID || 'com.arasana.web'

const iconApple = require('@/assets/images/icons/apple.svg')
const iconEmail = require('@/assets/images/icons/email.svg')
const iconGoogle = require('@/assets/images/icons/google2.svg')
const iconFacebook = require('@/assets/images/icons/facebook.svg')
const iconPhone = require('@/assets/images/icons/phone.svg')

export default {
  components: {
    BSpinner,
    BFormGroup,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BCardTitle,
    BImg,
    BOverlay,
  },
  data() {
    return {
      email: '',
      enableGoogleAuth: false,
      enableGoogleAuthInterval: null,
      enableGoogleAuthIntervalTime: 100,
      iconApple,
      iconEmail,
      iconGoogle,
      iconFacebook,
      iconPhone,
      locales,
      loading: false,
      socialCheck: true,
      termDidNotAccepted: false,
    }
  },
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  mounted() {
    initFbsdk()
  },
  created() {
    AppleID.auth.init({
      clientId: appleClientId,
      scope: 'name email',
      redirectURI: `${appUrl}/login`,
      state: new Date().getTime().toString(),
      usePopup: true,
    })

    this.enableGoogleAuthInterval = setInterval(() => {
      if (this.$gAuth.isInit) {
        clearInterval(this.enableGoogleAuthInterval)
        this.enableGoogleAuth = true
      }
    }, this.enableGoogleAuthIntervalTime)
  },
  methods: {
    emailCheck() {
      console.log('emailCheck')
      this.$refs.emailForm.validate().then(success => {
        if (success) {
          this.loading = true
          this.$emit('updateEmail', this.email)
          useJwt.emailVerification({ email: this.email, lang: this.$i18n.locale })
            .then(() => {
              // this.$emit('updateActiveComponent', 'PersonalInformation')
              this.$store.dispatch('auth/updateTempUser2', {})
              this.$emit('updateActiveComponent', 'Password')
              this.$emit('updateBackButton', 'SocialButtons')
              this.$store.dispatch('auth/setAuthType', 'email')
              this.loading = false
            })
            .catch(() => {
              gtmTrackNewEvent('registration', {
                category: 'Login Funnel',
                action: 'Registration',
              })
              this.$store.dispatch('auth/setAuthType', 'email')
              useJwt.forgotPasswordEmail({ email: this.email, lang: this.$i18n.locale })
                .catch(pinError => {
                  throwDefaultError(this.$toast, pinError)
                })
                .finally(() => {
                  this.$emit('updateActiveComponent', 'Password')
                  this.$emit('updateBackButton', 'SocialButtons')
                  this.loading = false
                })
            })
        }
      })
    },
    async loginWithApple() {
      try {
        const appleUserData = await AppleID.auth.signIn()

        // Handle successful response.
        if (typeof appleUserData.authorization.id_token === 'string') {
          const userInfo = {
            code: appleUserData.authorization.code,
            lang: this.$i18n.locale,
            deviceId: this.$store.getters['app/deviceId'],
          }

          this.loading = true

          useJwt
            .loginWithApple(userInfo)
            .then(response => {
              const data = response.data.body
              if (data.registrationStatus === 'pending') {
                this.$store.dispatch('auth/setAppleUser', data)
                this.$store.dispatch('auth/setTempUser', data)
                this.$store.dispatch('auth/setSocialRegistering', true)
                this.$emit('updateActiveComponent', 'PersonalInformation')
                this.$emit('updateBackButton', 'SocialButtons')
              } else {
                this.$store.dispatch('auth/setAppleUser', null)
                this.$store.dispatch('auth/setSocialRegistering', false)
                const defaultAbility = [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                  {
                    action: 'read',
                    subject: 'all',
                  },
                ]
                useJwt.setToken(data.loginToken.token)
                this.$store.dispatch('auth/setToken', data.loginToken.token)
                this.$store.dispatch('auth/updateUser', {
                  ability: defaultAbility,
                  ...data,
                })
                this.$ability.update(defaultAbility)
                this.$router.push(takeLoginRedirect() || '/')
              }
            })
            .catch(error => {
              throwDefaultError(this.$toast, error)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          // Email adresi yok uyarı göster
          showNotify(this.$toast, this.$t('Please give permission to share your email address and try again'), 'warning')
        }
      } catch (error) {
        throwDefaultError(this.$toast, error)
      }
    },
    loginWithGoogle() {
      this.loading = true
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          const userInfo = {
            accessToken: GoogleUser.getAuthResponse().id_token,
            userId: GoogleUser.getId(),
            lang: this.$i18n.locale,
            deviceId: this.$store.getters['app/deviceId'],
          }

          useJwt
            .loginWithGoogle(userInfo)
            .then(response => {
              const data = response.data.body
              if (data.registrationStatus === 'pending') {
                this.$store.dispatch('auth/setGoogleUser', data)
                this.$store.dispatch('auth/setTempUser', data)
                this.$store.dispatch('auth/setSocialRegistering', true)
                this.$emit('updateActiveComponent', 'PersonalInformation')
                this.$emit('updateBackButton', 'SocialButtons')
              } else {
                this.$store.dispatch('auth/setGoogleUser', null)
                this.$store.dispatch('auth/setSocialRegistering', false)
                const defaultAbility = [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                  {
                    action: 'read',
                    subject: 'all',
                  },
                ]
                useJwt.setToken(data.loginToken.token)
                this.$store.dispatch('auth/setToken', data.loginToken.token)
                this.$store.dispatch('auth/updateUser', {
                  ability: defaultAbility,
                  ...data,
                })
                this.$ability.update(defaultAbility)
                this.$router.push(takeLoginRedirect() || '/')
              }
            })
            .catch(error => {
              throwDefaultError(this.$toast, error)
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(error => {
          this.loading = false
          throwDefaultError(this.$toast, error)
        })
    },
    loginWithFacebook() {
      window.FB.login(response => {
        if (response && response.authResponse) {
          const userInfo = {
            accessToken: response.authResponse.accessToken,
            userId: response.authResponse.userID,
            lang: this.$i18n.locale,
            deviceId: this.$store.getters['app/deviceId'],
          }

          useJwt
            .loginWithFacebook(userInfo)
            .then(response2 => {
              const data = response2.data.body
              if (data.registrationStatus === 'pending') {
                this.$store.dispatch('auth/setFacebookUser', data)
                this.$store.dispatch('auth/setTempUser', data)
                this.$store.dispatch('auth/setSocialRegistering', true)
                this.$emit('updateActiveComponent', 'PersonalInformation')
                this.$emit('updateBackButton', 'SocialButtons')
              } else {
                this.$store.dispatch('auth/setFacebookUser', null)
                this.$store.dispatch('auth/setSocialRegistering', false)
                const defaultAbility = [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                  {
                    action: 'read',
                    subject: 'all',
                  },
                ]
                useJwt.setToken(data.loginToken.token)
                this.$store.dispatch('auth/setToken', data.loginToken.token)
                this.$store.dispatch('auth/updateUser', {
                  ability: defaultAbility,
                  ...data,
                })
                this.$ability.update(defaultAbility)
                this.$router.push(takeLoginRedirect() || '/')
              }
            })
            .catch(error => {
              throwDefaultError(this.$toast, error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      }, { scope: 'public_profile,email' })
    },
    showAcceptTerms() {
      this.termDidNotAccepted = true
      // showNotify(this.$toast, this.$t('Please accept the membership agreement.'), 'info')
    },
    triggerEmits(emits) {
      emits.forEach(emit => {
        this.$emit(emit.event, emit.args)
      })
    },
    // Method to show the Apple login info modal
    showAppleLoginInfoModal() {
      this.$refs.appleInfoModal.show()
    },
  },
}
</script>

<style>
#apple-info-modal___BV_modal_header_ {
  padding: 2.6rem 1.4rem !important;
}
</style>
